import React, { useState, useRef, useEffect } from 'react'
import { LogEntry } from '../types'
import useTranslate from '../useTranslate'
import { exportToCsv, exportToPdf } from '../services/exportService'
import useStyles from '../styles'

interface ExportButtonProps {
  entries: LogEntry[]
}

const ExportButton: React.FC<ExportButtonProps> = ({ entries }) => {
  const classes = useStyles()
  const t = useTranslate()
  const [open, setOpen] = useState(false)
  const wrapperRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent): void => {
      if (
        wrapperRef.current != null &&
        !wrapperRef.current.contains(e.target as Node)
      ) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  return (
    <div
      className={classes.exportWrapper}
      ref={wrapperRef}
    >
      <button
        className={classes.exportButton}
        onClick={() => setOpen(prev => !prev)}
      >
        <span
          className='material-symbols-outlined'
          style={{ fontSize: 16 }}
        >
          download
        </span>
        <span>{t('log_viewer.export')}</span>
        <span
          className='material-symbols-outlined'
          style={{ fontSize: 16 }}
        >
          expand_more
        </span>
      </button>
      {open && (
        <div className={classes.exportDropdown}>
          <button
            className={classes.exportItem}
            onClick={() => {
              exportToCsv(entries)
              setOpen(false)
            }}
          >
            <span
              className='material-symbols-outlined'
              style={{ fontSize: 16 }}
            >
              description
            </span>
            {t('log_viewer.export_csv')}
          </button>
          <button
            className={classes.exportItem}
            onClick={() => {
              void exportToPdf(entries)
              setOpen(false)
            }}
          >
            <span
              className='material-symbols-outlined'
              style={{ fontSize: 16 }}
            >
              picture_as_pdf
            </span>
            {t('log_viewer.export_pdf')}
          </button>
        </div>
      )}
    </div>
  )
}

export default ExportButton
